async function sendInitialAppEvents(almeApiUtils, almeState) {
    const responses = [];
    try {
        const launchParams = {
            LaunchPointName: almeState.launchPointName || "",
            LaunchParameter: almeState.launchParameter || "",
            LaunchType: 'Reactive',
        };
        const welcomeResponse = await almeApiUtils.sendAppEvent('WelcomeUser', undefined, launchParams);
        if (welcomeResponse) {
            responses.push(welcomeResponse);
        }
    }
    catch (error) {
        console.error(error);
    }
    return responses;
}
export default sendInitialAppEvents;
